module.exports = __webpack_public_path__ + "img/nswliberal.bf3e4bf.png";